import { Injectable } from '@angular/core';
import { DatasourceTableQuery } from '@y42/datasource';
import { DateTimeService } from '@y42/date-time';
import { GitQuery } from '@y42/git';
import { Y42FeatureType } from '@y42/json-schema';
import { IntegrationTableJobQuery } from '../datasource-table-job/integration-table-job.query';
import { IntegrationStoreQuery } from '../datasource/integration.store-query';
import { IntegrationTableStore } from './integration-table.store';

@Injectable({ providedIn: 'root' })
export class IntegrationTableQuery extends DatasourceTableQuery {
  constructor(
    protected readonly store: IntegrationTableStore,
    protected readonly parentQuery: IntegrationStoreQuery,
    protected readonly gitQuery: GitQuery,
    protected readonly integrationTableJobQuery: IntegrationTableJobQuery,
    protected readonly dateTimeService: DateTimeService,
  ) {
    super(store, parentQuery, gitQuery, integrationTableJobQuery, dateTimeService);
  }

  readonly featureType = Y42FeatureType.Integration;
}
